import { fetcher } from '@commenda/utils';
import { IIndirectTaxUpdateRegistrationStatusParams } from './types';

export async function updateIndirectTaxRegistrationStatus(
  registrationId: string,
  corporationId: number,
  body: IIndirectTaxUpdateRegistrationStatusParams
): Promise<{ success: boolean; message?: string; error?: string }> {
  try {
    const query = new URLSearchParams();
    query.append('corporationId', corporationId?.toString());

    const response = await fetcher(
      `new-sales-tax/internal/registrations-v2/${registrationId}/registration-status?${query}`,
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update registration status',
      };
    }

    const data = await response.json();
    return { success: true, message: data.message };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to update registration status';
    return { success: false, error: errorMessage };
  }
}
